import axios from 'axios';
import CryptoJS from 'crypto-js';

const Batch_PING_URL = 'https://serco.eprime.app/api/ping/batch';
const BASE_URL = 'https://serco.eprime.app/api/scheduler/schedule';


// const Batch_PING_URL = 'http://localhost:3500/api/ping/batch'
// const BASE_URL = 'http://localhost:3500/api/scheduler/schedule';

// Replace with your actual base URL
const AUTH_TOKEN = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsInJvbGUiOiJhZG1pbiJ9.wNzeQVdIoGM/AdRxOmkMV+vOVzmh6kkRUvbpYV1rtzg='; // Replace w
const ENCRYPTION_KEY='b14ca5898a4e4133bbce2ea2315a1916';
const IV='e5b8d7a3c6f9g8h1';



const encrypt = (data) => {
  const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY), {
    iv: CryptoJS.enc.Utf8.parse(IV),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();

  return ciphertext;
};

const decrypt = (ciphertext) => {
  const bytes = CryptoJS.AES.decrypt(ciphertext, CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY), {
    iv: CryptoJS.enc.Utf8.parse(IV),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};




// Middleware function to schedule a ping request
const schedulePingRequest =  async (ips, runAt) => {

  const requestBody = {
    route: Batch_PING_URL,
    headers: {
      Authorization: AUTH_TOKEN
    },
    body: {
      ips: ips, // Pass the IPs array from the frontend
      numPings: 4
    },
    run_at: runAt // Pass the run_at time from the frontend
  };

  // Encrypt the request body before sending
  const encryptedData = encrypt(requestBody);
const dataToSend = JSON.stringify({ ENCDATA: encryptedData });

  return axios.post(BASE_URL, dataToSend,{
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then(response => {
      
      return response.data; // Return the response data
    })
    .catch(error => {
      console.error('Error scheduling:', error.response ? error.response.data : error.message);
      throw new Error('Failed to schedule ping request');
    });
};

export default schedulePingRequest;